import BaseOverlay from "./base.jsx";
import SeatPicker from "../seat-picker.jsx";

export default ({ onRequestClose, event, order, onSubmit }) => {
  return (
    <BaseOverlay onRequestClose={onRequestClose}>
      <div style={{ textAlign: "center" }}>
        <SeatPicker
          event={event}
          order={order}
          onCancel={onRequestClose}
          updateCurrentOrder={({ subitems }) => {
            onSubmit(subitems);
          }}
        />
      </div>
    </BaseOverlay>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/seat-picker.jsx